﻿import { ISingleEpletMmRisk } from '@nkr/models/index';
export interface IDonorBM3ValidatorList {
    matchRunInclusion: string,
    matchPreSelectStatus: string,
    inMatch: boolean,
    matchInSwap: boolean,
    matchEpletRisk: string,
    isAvoid: false,
    donorId: number,
    donorAlias: string,
    donorType: string,
    donorAbo: string,
    donorAge: number,
    donorHeight: number,
    donorWeight: number,
    matchedPatientId: number,
    matchedPatientAlias: string,
    matchedPatientType: string,
    matchedPatientAbo: string,
    matchedPatientAge: number,
    matchedPatientHeight: number,
    matchedPatientWeight: number,
    matchedRecipientStatus: string,
    singleEpletMmRisk: ISingleEpletMmRisk,
    bmtMm: number,
    isCompatible: boolean,
    donorCenterId: number,
    recipientCenterId: number
}